import { eventConstants } from "../_constants";

const initState = {
  loading: true,
  productgroupsearch:null,
  error:""
}
export function productgroupsearch(state = initState, action) {
  switch (action.type) {
    case eventConstants.PRODUCT_GROUP_SEARCH_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case eventConstants.PRODUCT_GROUP_SEARCH_SUCCESS:
      return {
        ...state,
        productgroupsearch: action.productgroupsearch,
        loading:false
      };
    case eventConstants.PRODUCT_GROUP_SEARCH_FAILURE:
      return {
        ...state,
        error: action.error,
        loading:false,
        productgroupsearch:null
      };

      case eventConstants.PRODUCT_GROUP_SEARCH_CLEAR:
        return {
          productgroupsearch: '',
          error: ''
        };
    default:
      return state;
  }
}